import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';
import { css } from 'linaria';
import { storeContactsContainer } from './store-contacts';
import { storeVacanciesContainer } from './store-vacancies/styles';

export const StoreInfoContainer = styled.div`
  display: grid;
  grid-column-gap: var(--space-900);
  grid-row-gap: var(--space-800);
  grid-template-columns: 41.079295fr 58.920705fr;
  ${breakpoints.from.largeDesktop} {
    grid-column-gap: 82px;
    grid-row-gap: var(--space-1000);
  }
  ${breakpoints.to.desktop} {
    grid-template-columns: 100%;
  }
  ${breakpoints.only.tablet} {
    grid-template-rows: auto;
  }
  ${breakpoints.only.mobile} {
    grid-row-gap: var(--space-600);
  }
`;
export const mapContainer = css`
  position: relative;
  grid-area: 1 / 2 / 2 / 2;
  min-height: 300px;
  margin-bottom: -24px;
  overflow: hidden;
  border-radius: var(--rounding-l);
  box-shadow: 0 0 1px rgb(0 0 0 / 60%);

  ${breakpoints.from.largeDesktop} {
    margin-bottom: -40px;
  }

  ${breakpoints.to.desktop} {
    grid-area: 2 / 1 / 3 / 2;
  }
  ${breakpoints.to.tablet} {
    height: 0;
    border: 0;
  }
`;

export const modalHeader = css`
  display: flex;
  flex-direction: column;
  padding: var(--space-500) 0 var(--space-200) var(--space-500);
  color: var(--text-primary);

  ${breakpoints.only.mobile} {
    padding: var(--space-500) 0 var(--space-200) var(--space-200);
  }
`;

export const modalCaption = css`
  margin-top: var(--space-100) !important;
`;

export const modalFooter = css`
  ${breakpoints.only.mobile} {
    padding-bottom: var(--space-400) !important;
  }
`;

export const pickupPoint = css`
  .${mapContainer} {
    ${breakpoints.from.desktop} {
      grid-area: 1 / 2 / 4 / 2;
    }
  }
  ${breakpoints.only.tablet} {
    .${String(storeContactsContainer)} {
      grid-area: 4 / 1 / 5 / 2;
    }
    .${storeVacanciesContainer} {
      grid-area: 5 / 1 / 6 / 3;
    }
  }
  ${breakpoints.to.tablet} {
    .${String(storeContactsContainer)} {
      grid-area: 3 / 1 / 4 / 2;
    }
    .${storeVacanciesContainer} {
      grid-area: 4 / 1 / 5 / 3;
    }
  }
`;

export const loaderStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
